// extracted by mini-css-extract-plugin
module.exports = {"root":"DateRangePicker_root__3rfIt","errorMsg":"DateRangePicker_errorMsg__3j8c9","mainError":"DateRangePicker_mainError__2BERf"};